import { render, staticRenderFns } from "./IngresarPago.vue?vue&type=template&id=e80f6c86&lang=pug"
import script from "./IngresarPago.vue?vue&type=script&lang=js"
export * from "./IngresarPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports